import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";

import FormContent from "components/organisms/formContent/index.jsx";

import Button from "components/atoms/button/index.jsx";
import FormFieldset from "components/molecules/formFieldset/index.jsx";
import FormCol from "components/molecules/formCol/index.jsx";
import FormTextField from "components/molecules/formTextField/index.jsx";
import FormSelect from "components/molecules/formSelect/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

import validation from "./validation";

class RequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      models: [],
      brand: "",
      model: "",
      engine: "",
    };
  }

  getModels() {
    return this.props.models.filter((model) => {
      return model.id_brand === this.props.brandId;
    });
  }

  render() {
    const models = this.getModels();

    const { handleSubmit, pristine, submitting } = this.props;

    return (
      <FormContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <FormFieldset>
            <h3>Tus datos </h3>

            <FormCol first="true">
              <Field
                name="name"
                type="text"
                component={FormTextField}
                label="Nombre"
              />

              <Field
                name="telephone"
                type="text"
                component={FormTextField}
                label="Teléfono"
              />
            </FormCol>

            <FormCol last="true">
              <Field
                name="lastname"
                type="text"
                component={FormTextField}
                label="Apellido"
              />

              <Field
                name="cellphone"
                type="text"
                component={FormTextField}
                label="Celular"
              />
            </FormCol>

            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Correo electrónico"
            />

            <h3>Contanos qué buscás</h3>

            <div className="textCol">
              <p className="b">
                Seleccioná las opciones que mejor describan al vehículo que
                estás buscando.
              </p>
              <br />
            </div>

            <Field
              name="bodyId"
              component={FormSelect}
              label="Carrocería"
              appendEmptyOption={true}
              options={this.props.bodies}
              onChange={(e, id) => {
                const body = this.props.bodies?.find((body) => body.id === id);

                this.props.change("body", body?.name);
              }}
            />

            <Field
              name="brandId"
              component={FormSelect}
              label="Marca"
              appendEmptyOption={true}
              options={this.props.brands}
              onChange={(e, id) => {
                const brand = this.props.brands?.find(
                  (brand) => brand.id === id
                );

                this.setState({ brand: brand?.name });

                this.props.change(
                  "vehicle",
                  `${brand?.name} ${this.state.model} ${this.state.engine}`
                );
              }}
            />

            <Field
              name="modelId"
              component={FormSelect}
              label="Modelo"
              appendEmptyOption={true}
              options={models}
              onChange={(e, id) => {
                const model = this.props.models?.find(
                  (model) => model.id === id
                );

                this.setState({ model: model?.name });

                this.props.change(
                  "vehicle",
                  `${this.state.brand} ${model?.name} ${this.state.engine}`
                );
              }}
            />

            <Field
              name="engineId"
              component={FormSelect}
              label="Motor"
              appendEmptyOption={true}
              options={this.props.engines}
              onChange={(e, id) => {
                const engine = this.props.engines?.find(
                  (engine) => engine.id === id
                );

                this.setState({ engine: engine?.name });

                this.props.change(
                  "vehicle",
                  `${this.state.brand} ${this.state.model} ${engine?.name}`
                );
              }}
            />

            <Field
              name="priceMax"
              label="Precio máximo que buscás"
              type="text"
              component={FormTextField}
              placeholder="Precio máximo"
            />

            <FormCol first="true">
              <Field
                name="kmMin"
                label="Mínimo de kilómetros"
                type="text"
                component={FormTextField}
                placeholder="Kilometraje mínimo"
              />
            </FormCol>
            <FormCol last="true">
              <Field
                name="kmMax"
                label="Maxima cantidad de kilómetros"
                type="text"
                component={FormTextField}
                placeholder="Kilometraje máximo"
              />
            </FormCol>

            <FormCol first="true">
              <Field
                name="yearMin"
                label="Año de fabricación mínimo"
                type="text"
                component={FormTextField}
                placeholder="Año mínimo"
              />
            </FormCol>

            <FormCol last="true">
              <Field
                name="yearMax"
                label="Año de fabricación máximo"
                type="text"
                component={FormTextField}
                placeholder="Año máximo"
              />
            </FormCol>
          </FormFieldset>
          <FormActions>
            <Button
              disabled={pristine || submitting}
              buttonText="Hacer pedido"
              type="submit"
            />
          </FormActions>
        </form>
      </FormContent>
    );
  }
}

RequestForm = reduxForm({
  form: "request",
  validate: validation,
})(RequestForm);

const selector = formValueSelector("request");

export default connect((state) => {
  const brandId = selector(state, "brandId");
  const modelId = selector(state, "modelId");
  const engineId = selector(state, "engineId");

  return {
    brandId,
    modelId,
    engineId,
  };
})(RequestForm);
